import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';


import ReactTable from "react-table";
import "react-table/react-table.css";

import Spinner from 'react-spinkit';

import moment from 'moment';

import * as actions from '../../actions/factura';

import IconSave from 'react-icons/lib/md/save';


import {api, request, API_URL} from '../../actions/_request';

import swal from 'sweetalert2';
import Select , {Async}  from 'react-select';
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const meses = [
  {label : 'Enero' , value : 1},
  {label : 'Febrero', value : 2},
  {label : 'Marzo', value : 3},
  {label : 'Abril' , value: 4},
  {label : 'Mayo' , value: 5},
  {label : 'Junio' , value: 6},
  {label : 'Julio' , value: 7},
  {label : 'Agosto' , value: 8},
  {label : 'Septiembre' , value: 9},
  {label : 'Octubre' , value: 10},
  {label : 'Noviembre' , value: 11},
  {label : 'Diciembre' , value: 12},
];
const tipos_precios = [
{label: 'Todos', value: 999}, 
  {label: 'Hardware', value: 0},
  {label: 'Administrativo', value: 1}, 
  {label: 'Comisiones', value: 2}, 
   {label: 'Sin Clasificar', value: 3}, 
];
const motivos = [
{label: 'Todos', value: 999},
  {label: 'Hardware', value: 0},
  {label: 'Administrativo', value: 1}, 
  {label: 'Personal', value: 2}, 
];
const tipo_compra = [
{label: 'Todos', value: 999},
  {label: 'Produccion', value: 0},
  {label: 'Proyecto', value: 1}, 
 
];
class KardexProveedor extends React.Component{
	constructor(props) {

        super(props);

        this.state = {
           	fecha_inicio :  moment().format('Y-MM-DD'),
           	fecha_fin 	 : moment().add(1, 'days').format('Y-MM-DD'),
            filtro : 3,
            tipo_gastos:999,
            motivo:999,
            tipo_id:999,
        };
        
        this.buscar = this.buscar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this); 
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleSelectChange2 = this.handleSelectChange2.bind(this);
    }

    handleSelectChange2(select, name) {

        
        const valor = select === null ? null : select.value;
        this.setState({
           
             
                [name]: valor,
                buscar:0,
        
        });
    }

    componentDidMount(){
    let self = this;

        var fecha = new Date();
        var ano = fecha.getFullYear();
        let anos=[];

        for (var i = 5 ; i >= 0; i--) {
          anos.unshift({label:(ano-i),value:(ano-i)});
        }



        this.setState({
          mes : parseInt(fecha.getMonth())+1,
          ano:ano,
          anos:anos,
        });
       
        
        
    }

    handleInputChange(event) {
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    handleSelectChange(select, name) {

        const value = select === null ? null : select.target.value;
        const nameSelect = select.target.name;

        this.setState({[nameSelect] : value});

    }

    buscar(evt){
    	evt.preventDefault();

    	let {ano,mes,tipo_gastos,motivo,tipo_id} = this.state;
    	let {  consulta} = this.props;

      console.log('consulta--->',consulta);

      
       window.open(`${API_URL}/reporte_facturas_compra/${ano}/${mes}/${tipo_gastos}/${motivo}/${tipo_id}`);
      
    }

    render(){
    	let {fecha_inicio , fecha_fin ,filtro} = this.state;
    	return(
    		<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}></ModalHeader>
                <ModalBody>
                	<div className="row">
                		<div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Mes:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="mes"
                            options={meses}
                            value={parseInt(this.state.mes) || 1}
                           onChange={ (select) => { this.handleSelectChange2(select, 'mes') } }
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Año:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="ano"
                            options={this.state.anos}
                            value={parseInt(this.state.ano) || 1}
                           onChange={ (select) => { this.handleSelectChange2(select, 'ano') } }
                            clearable={false}

                        />
                    </div>
                </div>
                    
                	</div>
               
                    <div className="row">
                      <div className="col-12 col-sm-6 ">
                              <div className="form-group">
                                <label className>Tipo de Gastos:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="tipo_gastos"
                                  options={tipos_precios}
                                  value={parseInt(this.state.tipo_gastos) || 0}
                                  onChange={ (select) => { this.handleSelectChange2(select, 'tipo_gastos') } }
                                  clearable={false}
                                  className="form-group"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 ">
                              <div className="form-group">
                                <label className>Tipo de Compra:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="tipo_id"
                                  options={tipo_compra}
                                  value={parseInt(this.state.tipo_id) || 0}
                                  onChange={ (select) => { this.handleSelectChange2(select, 'tipo_id') } }
                                  clearable={false}
                                  className="form-group"
                                />
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 ">
                              <div className="form-group">
                                <label className>Tipo de Motivo:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="motivo"
                                  options={motivos}
                                  value={parseInt(this.state.motivo) || 0}
                                  onChange={ (select) => { this.handleSelectChange2(select, 'motivo') } }
                                  clearable={false}
                                  className="form-group"
                                />
                              </div>
                            </div>
                    </div> 
                  
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.factura.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.buscar} >
                                <IconSave />&nbsp;Buscar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
    	);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(KardexProveedor)


// WEBPACK FOOTER //
// ./src/components/compras/modal_reportes.js